const _u = {
	readC : function(name) {
		var qName = name + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(qName) === 0) return c.substring(qName.length, c.length);
		}
		return "";
	},
	readQ : function(name) {
		var qName = name.toLowerCase() + "=";
		if (document.URL.indexOf("?") == -1) {
			return "";
		}
		var _url = document.URL.split('?');
		var ca = String(_url[1]).toLowerCase().split('&');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(qName) === 0) return c.substring(qName.length, c.length);
		}
		return "";
	},
	urlClean : function(a) {
		a = a.toLowerCase();
		a = a.split("https://www.").join("");
		a = a.split("http://www.").join("");
		a = a.split("https://").join("");
		a = a.split("http://").join("");
		a = a.split("www.").join("");
		a = a.split(".html").join("");
		a = a.split(".htm").join("");
		a = a.split(".aspx").join("");
		a = a.split(".asp").join("");
		a = a.split("default").join("");
		a = a.split(" ").join("-");
		return a;
	},
	//generates new s_pageview id which will be passed as pvid
	GenPVID : function(noAdRefresh) {
		// getting the date, getting the seconds from epoch
		var timestamp = new Date().getTime() / 1000;
		//Rounding the decimal off
		var epochSec = Math.round(timestamp).toString();
		// making an 8 digit random number
		var randomNumber = Math.random().toString().substr(2, 8);
		// set the global variable to the 19 digit page view id
		var tempPVIDreturn = epochSec + randomNumber;
		window.s_pageview_id = tempPVIDreturn;
		if (typeof noAdRefresh == 'boolean' && noAdRefresh) {
			document.dispatchEvent(new CustomEvent('pvidReset', {detail: true}));
		} else {
			document.dispatchEvent(new CustomEvent('pvidReset'));
		}
		
	},
	isObject : function(item) {
		return (item && typeof item === 'object' && !Array.isArray(item));
	},
	//method to deep merge nested objects as .assign only performs a shallow merge
	mergeDeep : function(target, ...sources) {
	  if (!sources.length) return target;
	  const source = sources.shift();
	  if (_u.isObject(target) && _u.isObject(source)) {
		for (const key in source) {
		  if (_u.isObject(source[key])) {
			if (!target[key]) Object.assign(target, { [key]: {} });
				_u.mergeDeep(target[key], source[key]);
		  } else {
				Object.assign(target, { [key]: source[key] });
		  }
		}
	  }
	  return _u.mergeDeep(target, ...sources);
	}
	
};

export default _u;

window._urlClean = _u.urlClean; // Expose legacy '_urlClean' function to global

/* CODE BELOW NOT EXPORTED AS PART OF MODULE, SIMPLY RUNS ONCE ON INIT */
(function() { // CustomEvent Polyfill
	if (typeof window.CustomEvent === "function") return false;

	function CustomEvent(event, params) {
		params = params || {
			bubbles: false,
			cancelable: false,
			detail: undefined
		};
		var evt = document.createEvent('CustomEvent');
		evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
		return evt;
	}

	CustomEvent.prototype = window.Event.prototype;
	window.CustomEvent = CustomEvent;
})();